import React, { createContext, useContext, useState, useCallback } from 'react';
import fr from './fr';
import nl from './nl';
import en from './en';

const translations = { fr, nl, en };

const LanguageContext = createContext();

export const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷🇧🇪' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱🇧🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('motivya_lang');
    if (saved) return saved;
    const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
    let detected = 'fr';
    if (browserLang.startsWith('nl')) detected = 'nl';
    else if (browserLang.startsWith('en')) detected = 'en';
    localStorage.setItem('motivya_lang', detected);
    return detected;
  });

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem('motivya_lang', code);
  }, []);

  const t = useCallback((key, params) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    if (val == null) return key;
    if (params && typeof val === 'string') {
      return val.replace(/\{\{(\w+)\}\}/g, (_, p) => params[p] ?? '');
    }
    return val;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation must be inside LanguageProvider');
  return ctx;
}
